import { IQuoteTemplateState } from '@/store/quotetemplate';
import { IQuoteTemplateMutations } from './mutations.types';
import {
  IQuoteFreightTemplateData,
  IQuotePaymentTermTemplateData,
  IQuoteServiceTemplateData,
  IQuoteTermTemplateData
} from '@/models';

export const mutations: IQuoteTemplateMutations = {
  SET_QUOTE_SERVICE_TEMPLATES(
    state: IQuoteTemplateState,
    payload: IQuoteServiceTemplateData[]
  ): void {
    state.serviceTemplates = payload;
  },

  ADD_QUOTE_SERVICE_TEMPLATE(
    state: IQuoteTemplateState,
    payload: IQuoteServiceTemplateData
  ): void {
    state.serviceTemplates.push(payload);
  },

  UPDATE_QUOTE_SERVICE_TEMPLATE(
    state: IQuoteTemplateState,
    payload: IQuoteServiceTemplateData
  ): void {
    const index = state.serviceTemplates.findIndex(
      (template: IQuoteServiceTemplateData) => template.id === payload.id
    );

    state.serviceTemplates.splice(index, 1, payload);
  },

  REMOVE_QUOTE_SERVICE_TEMPLATE(
    state: IQuoteTemplateState,
    payload: number
  ): void {
    const index = state.serviceTemplates.findIndex(
      (template: IQuoteServiceTemplateData) => template.id === payload
    );

    state.serviceTemplates.splice(index, 1);
  },

  //FREIGHTS
  SET_QUOTE_FREIGHT_TEMPLATES(
    state: IQuoteTemplateState,
    payload: IQuoteFreightTemplateData[]
  ): void {
    state.freightTemplates = payload;
  },

  ADD_QUOTE_FREIGHT_TEMPLATE(
    state: IQuoteTemplateState,
    payload: IQuoteFreightTemplateData
  ): void {
    state.freightTemplates.push(payload);
  },

  UPDATE_QUOTE_FREIGHT_TEMPLATE(
    state: IQuoteTemplateState,
    payload: IQuoteFreightTemplateData
  ): void {
    const index = state.freightTemplates.findIndex(
      (template: IQuoteFreightTemplateData) => template.id === payload.id
    );

    state.freightTemplates.splice(index, 1, payload);
  },

  REMOVE_QUOTE_FREIGHT_TEMPLATE(
    state: IQuoteTemplateState,
    payload: number
  ): void {
    const index = state.freightTemplates.findIndex(
      (template: IQuoteFreightTemplateData) => template.id === payload
    );

    state.freightTemplates.splice(index, 1);
  },

  //PAYMENT TERMS
  SET_QUOTE_PAYMENT_TERM_TEMPLATES(
    state: IQuoteTemplateState,
    payload: IQuotePaymentTermTemplateData[]
  ): void {
    state.paymentTermTemplates = payload;
  },

  ADD_QUOTE_PAYMENT_TERM_TEMPLATE(
    state: IQuoteTemplateState,
    payload: IQuotePaymentTermTemplateData
  ): void {
    state.paymentTermTemplates.push(payload);
  },

  UPDATE_QUOTE_PAYMENT_TERM_TEMPLATE(
    state: IQuoteTemplateState,
    payload: IQuotePaymentTermTemplateData
  ): void {
    const index = state.paymentTermTemplates.findIndex(
      (template: IQuotePaymentTermTemplateData) => template.id === payload.id
    );

    state.paymentTermTemplates.splice(index, 1, payload);
  },

  REMOVE_QUOTE_PAYMENT_TERM_TEMPLATE(
    state: IQuoteTemplateState,
    payload: number
  ): void {
    const index = state.paymentTermTemplates.findIndex(
      (template: IQuotePaymentTermTemplateData) => template.id === payload
    );

    state.paymentTermTemplates.splice(index, 1);
  },

  //TERMS
  SET_QUOTE_TERM_TEMPLATES(
    state: IQuoteTemplateState,
    payload: IQuoteTermTemplateData[]
  ): void {
    state.termTemplates = payload;
  },

  SET_QUOTE_TERM_TEMPLATES_ORDER(
    state: IQuoteTemplateState,
    payload: IQuoteTermTemplateData[]
  ): void {
    // Create a map of id values to term's order in the new list
    const newPayloadMap = new Map<number, number>();
    payload.forEach(term => newPayloadMap.set(term.id!, term.order!));

    // Replace objects in the existing terms list with order from the new list
    const updatedTerms = state.termTemplates.map(term => {
      if (newPayloadMap.has(term.id!)) {
        const termOrder = newPayloadMap.get(term.id!);
        return {
          ...term,
          order: termOrder
        };
      }
      return term;
    });

    updatedTerms.sort(
      (termA: IQuoteTermTemplateData, termB: IQuoteTermTemplateData) =>
        termA.order! - termB.order!
    );

    state.termTemplates = updatedTerms;
  },

  ADD_QUOTE_TERM_TEMPLATE(
    state: IQuoteTemplateState,
    payload: IQuoteTermTemplateData
  ): void {
    state.termTemplates.push(payload);
  },

  UPDATE_QUOTE_TERM_TEMPLATE(
    state: IQuoteTemplateState,
    payload: IQuoteTermTemplateData
  ): void {
    const index = state.termTemplates.findIndex(
      (template: IQuoteTermTemplateData) => template.id === payload.id
    );

    state.termTemplates.splice(index, 1, payload);
  },

  REMOVE_QUOTE_TERM_TEMPLATE(
    state: IQuoteTemplateState,
    payload: number
  ): void {
    const index = state.termTemplates.findIndex(
      (template: IQuoteTermTemplateData) => template.id === payload
    );

    state.termTemplates.splice(index, 1);
  }
};
